import {
  PARAGRAPH_SPACING_VALUES,
  hasParagraphSpacing,
  setParagraphSpacing
} from '../utils/paragraphSpacing';

const SIDE_NAMES = {
  before: 'paragraphSpacingBefore',
  after: 'paragraphSpacingAfter'
};

// `8pt` is shown as "8 pt", the way Word writes it.
const spacingList = () =>
  Object.fromEntries(
    PARAGRAPH_SPACING_VALUES.map((value) => [value, value.replace('pt', ' pt')])
  );

const spacingControl = (t, side) => ({
  name: SIDE_NAMES[side],
  text: t(`template-documents.paragraph_spacing.${side}`),
  tooltip: t(`template-documents.paragraph_spacing.${side}_tooltip`),
  list: spacingList(),
  isChildActive: (editor, button) =>
    hasParagraphSpacing(editor, side, button?.control?.args?.[0]),
  exec: (editor, _, { control } = {}) => {
    const value = control?.args?.[0];
    // No value: the toolbar button itself was clicked, let Jodit open the list.
    if (!value) return false;
    setParagraphSpacing(editor, side, value);
    return true;
  }
});

/**
 * Builds the two Word-like paragraph spacing controls, "space before" and
 * "space after", each listing the values in points.
 * @function
 *
 * @param {Function} t - The i18next translation function.
 * @returns {Object[]} The two Jodit controls, before then after.
 */
export const paragraphSpacingButtons = (t) => [
  spacingControl(t, 'before'),
  spacingControl(t, 'after')
];
